import { Column, Row, Switch } from '@melements/front-components';
import React from 'react';
import { Field, FieldRenderProps } from 'react-final-form';

import { ServiceFormColumn, ServiceFormLabel } from './Service.styles';
import { ServiceProps } from './Service.types';

export const Service = ({ service }: ServiceProps) => {
  return (
    <Row>
      <Column>
        <ServiceFormLabel>{service.toUpperCase()}</ServiceFormLabel>
      </Column>
      <ServiceFormColumn>
        <Field name={service} type="checkbox">
          {({ input }: FieldRenderProps<any>) => <Switch input={input} className="switch--service_enabled" />}
        </Field>
      </ServiceFormColumn>
    </Row>
  );
};
